<template>
  <div class="about">
    <router-link class="back-button" to="/">
      <arrow-left-icon size="1.5x" class="mr-2 back-button__icon"></arrow-left-icon>
      {{this.$t('jobDetails.backToJobs')}}
    </router-link>
    <JobDetailsItem :job="job" @shareJob="toogleShareModal" @applyJob="toogleApplyModal"/>
    <ShareModal :visible.sync="showShareModal" :job="job" @closeModal="toogleShareModal"/>
    <ApplyModal :visible.sync="showApplyModal" :job="job" @closeModal="toogleApplyModal"/>
    <router-link class="back-button justify-center" to="/">
      <arrow-left-icon size="1.5x" class="mr-2 back-button__icon"></arrow-left-icon>
      {{this.$t('jobDetails.backToJobs')}}
    </router-link>
  </div>
</template>
<script>
  import JobDetailsItem from '../components/JobDetailsItem'
  import ShareModal from '../components/modals/ShareModal'
  import ApplyModal from '../components/modals/ApplyModal'
  import { ArrowLeftIcon } from 'vue-feather-icons'

  export default {
    name: 'job-details',
    components: { ApplyModal, ArrowLeftIcon, ShareModal, JobDetailsItem },
    computed: {
      job () {
        let job = this.$store.state.currentJob
        if (!job) {
          return
        }
        return job
      }
    },
    data () {
      return {
        showShareModal: false,
        showApplyModal: false,
      }
    },
    async created () {
      await this.$store.dispatch('getJobBySlug', this.$route.params.slug)
    },
    methods: {
      toogleShareModal () {
        this.showShareModal = !this.showShareModal
      },
      toogleApplyModal () {
        this.showApplyModal = !this.showApplyModal
      }
    }
  }
</script>
